"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { Drawer } from "../../Drawer/index.js";
import { OverlaySearchHeader, OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { Calendar } from "../Calendar/Calendar.js";
function DatePickerMobileComponent({ mode = 'single', handleCalendarChange, components, open = false, handleDrawerState, heading = 'Choose Dates', popOverText, selected, footer, subHeading, autoFocus, ...restProps }) {
    const handleClose = useCallback(()=>{
        handleDrawerState(false);
    }, [
        handleDrawerState
    ]);
    const headingCustomNode = useMemo(()=>/*#__PURE__*/ jsx(OverlaySearchHeader, {
            children: /*#__PURE__*/ jsx(OverlayTitle, {
                heading: heading,
                subHeading: subHeading,
                handleClose: handleClose,
                popOverText: popOverText
            })
        }), [
        heading,
        subHeading,
        popOverText,
        handleClose
    ]);
    return /*#__PURE__*/ jsx(Drawer.Root, {
        open: open,
        onOpenChange: handleDrawerState,
        snapPoints: [
            1
        ],
        children: /*#__PURE__*/ jsxs(Drawer.Portal, {
            children: [
                /*#__PURE__*/ jsx(Drawer.Backdrop, {}),
                /*#__PURE__*/ jsx(Drawer.Viewport, {
                    children: /*#__PURE__*/ jsxs(Drawer.Popup, {
                        height: "full",
                        children: [
                            /*#__PURE__*/ jsx(Drawer.Title, {
                                className: "sr-only",
                                children: "Calendar"
                            }),
                            /*#__PURE__*/ jsx(Drawer.Description, {
                                className: "sr-only",
                                children: "Overlay Calendar"
                            }),
                            headingCustomNode,
                            /*#__PURE__*/ jsx("div", {
                                className: "relative flex w-full flex-1 overflow-y-auto p-4",
                                children: /*#__PURE__*/ jsx(Calendar, {
                                    ...restProps,
                                    autoFocus: autoFocus,
                                    mode: mode,
                                    handleCalendarChange: handleCalendarChange,
                                    components: components,
                                    selected: selected,
                                    scrollToSelectedMonthOnOpen: open && !!autoFocus
                                })
                            }),
                            footer && /*#__PURE__*/ jsx("div", {
                                className: "sticky right-0 bottom-0 left-0",
                                children: footer
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const DatePickerMobile = /*#__PURE__*/ memo(DatePickerMobileComponent);
export { DatePickerMobile };
